var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRight2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99951 2.16699C14.3233 2.16699 17.8333 5.67629 17.8335 10C17.8335 14.3239 14.3234 17.834 9.99951 17.834C5.6758 17.8338 2.1665 14.3237 2.1665 10C2.16668 5.6764 5.67591 2.16717 9.99951 2.16699ZM11.2114 6.70508C10.8019 6.29571 10.1468 6.26981 9.70654 6.62793L9.62158 6.70508C9.21188 7.11478 9.1858 7.77059 9.54443 8.21094L9.62158 8.2959L10.2007 8.875H7.0835C6.4658 8.875 5.95867 9.38234 5.9585 10C5.9585 10.6178 6.46569 11.125 7.0835 11.125H10.2017L9.62158 11.7051C9.18465 12.142 9.18465 12.859 9.62158 13.2959C9.84524 13.5194 10.1329 13.625 10.4165 13.625C10.6647 13.625 10.9158 13.544 11.1245 13.374L11.2114 13.2959L13.7114 10.7959C14.1211 10.3863 14.147 9.73038 13.7886 9.29004L13.7114 9.20508L11.2114 6.70508Z",
    fill: "#292D32",
    stroke: "#133253"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRight2);
export default __webpack_public_path__ + "static/media/right2.ee5c6ca3c0b7c86a47b3e1a459b1fd5a.svg";
export { ForwardRef as ReactComponent };